import React from "react"

const PostDetails = () => {
  console.log("POST Details")
  return <div>PostDetails</div>
}

export default PostDetails
